import { useEffect, useState } from 'react';

// True once the window has scrolled past `threshold` pixels.
// Drives the nav shadow (40px) and the back-to-top button (600px).
export function useScrollFlag(threshold) {
  const [passed, setPassed] = useState(false);

  useEffect(() => {
    const onScroll = () => setPassed(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return passed;
}
